import * as React from 'react';
import { Link } from 'react-router';
import { withDropdownMenu } from 'ui/common/dropdown-menu';
import { MeatballMenu } from 'ui/common/dropdown-menu/meatball-menu';
import { SharedState } from 'app/types-shared';
import { ExcelLinks } from './favourite-excel-links';
import { DropdownMenuContext } from 'ui/common/dropdown-menu/types';
import styles from './display-options.scss';
import { FavouriteReportDownload } from 'app/area/favourite/types';
import { reportTypes } from 'app/area/favourite/constants';
import { routeConstants } from 'app/routes/route-constants';
import { isValidUrl } from 'app/infrastructure/validation/url';
import { urlToSurveyManager } from 'app/area/favourite/components/url-to-survey-manager';
import { Link as ExternalLink } from 'ui';
import { triggerPrintDialog } from 'app/infrastructure/platform';

interface FavouriteContextMenuProps {
  favouriteId: number;
  report: number;
  translation: any;
  sharedState: SharedState;
  createReport: () => void;
  updateReport: () => void;
  showUpdate: boolean;
  displayExportToZip: () => void;
  downloadReport: (data: FavouriteReportDownload) => void;
  getMulitpleSuppliersUrl: () => void;
  urlMultipleSuppliers: string;
}

const FavouriteContextItem = withDropdownMenu((props: DropdownMenuContext & { onClick: () => void, label: string }) => {

  const { label, onClick, handleDropdownHide } = props;
  const onClickHandler = () => {
    handleDropdownHide();
    onClick();
  };

  return <li>
    <button type="button" className="dropdown-item" onClick={onClickHandler}>
      {label}
    </button>
  </li>;
});

export class FavouriteContextMenu extends React.Component<FavouriteContextMenuProps, any> {

  private fetchMultipleSuppliersUrl = () => {
    this.props.getMulitpleSuppliersUrl && this.props.getMulitpleSuppliersUrl();
  }

  private onCreateReport = () => {
    this.props.createReport();
  };
  private onUpdateReport = () => {
    this.props.updateReport();
  }

  private onPrint = () => {
    triggerPrintDialog();
  }

  private onDownloadReport = () => {
    this.props.downloadReport({
      favouriteId: this.props.favouriteId,
      reportId: this.props.report,
      successMessage: () => <Link
        style={{ color: '#fff' }}
        to={routeConstants.myDownloadsView}>
        {this.props.translation.download_report_success}
      </Link>
    });
  };

  public render() {
    const {translation, urlMultipleSuppliers} = this.props;

    return <div className={styles.meatball}>
      <MeatballMenu onExpandMenu={this.fetchMultipleSuppliersUrl}>
        <FavouriteContextItem label={translation.create_report_title} onClick={this.onCreateReport} />
        {this.props.showUpdate &&
          <FavouriteContextItem label={translation.update_report_title} onClick={this.onUpdateReport} />}
        {this.props.sharedState.access && this.props.sharedState.access.tools.exportAndImport.export &&
          <FavouriteContextItem label={translation.export_title} onClick={this.props.displayExportToZip} />}
        {this.props.report === reportTypes.selectionReport
          && <FavouriteContextItem label={translation.download_selection_report_title}
            onClick={this.onDownloadReport} />}
        {this.props.report === reportTypes.frequencyReport
          && <FavouriteContextItem label={translation.download_frequency_report_title}
            onClick={this.onDownloadReport} />}
        <ExcelLinks {...this.props} />
        {this.props.sharedState.access && this.props.sharedState.access.surveyManager.send && urlMultipleSuppliers &&
          isValidUrl(urlToSurveyManager(urlMultipleSuppliers, this.props.favouriteId))
            && <ExternalLink url={urlToSurveyManager(urlMultipleSuppliers, this.props.favouriteId)}
              linkText={translation.open_in_survey_manager} className={'dropdown-item'} />}
        <FavouriteContextItem label={translation.print_displayed} onClick={this.onPrint} />
      </MeatballMenu>
    </div>;
    }
}
